import script from "./FuelTypesView.vue?vue&type=script&setup=true&lang=js"
export * from "./FuelTypesView.vue?vue&type=script&setup=true&lang=js"

import "./FuelTypesView.vue?vue&type=style&index=0&id=76d3dc78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d3dc78"]])

export default __exports__